// extracted by mini-css-extract-plugin
export default {"background":"styles_background__fHnt7","infront":"styles_infront__cMnK0"};